<template>
  <!-- modal -->
  <div class="dimed wrap">
    <div class="layer">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.Card.msg1') }}</div>
        <div class="ft-point">
          {{ $t('Modal.Card.msg2') }}
        </div>
        <div class="lyr-txt">{{ $t('Modal.Card.msg3') }}</div>
      </div>
      <div class="layer__body">
        <img :src="cardImgSrc" style="height: 370px" alt="" />
      </div>
      <div class="layer__button" v-if="isSimpleToken">
        <button class="btn btn--line btn--xlg btn-anim" @mouseup="cancelPayment()">{{ $t('Modal.Card.msg9') }}</button>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'card',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      isSimpleToken: this.$store.getters.getIsSimpleToken,
      cardImgSrc: '',
      cancelYn: false,
      oneCallYn: false,
      tranUrl: '',
      text: ''
    };
  },
  mounted() {
    if (this.$i18n.locale == 'jp') {
      this.cardImgSrc = require('@/assets/images/user/artwork_popup_card_3d_jp.gif');
    } else {
      this.cardImgSrc = require('@/assets/images/user/artwork_popup_card_3d_ko.gif');
    }

    this.paymentEnd();
  },
  props: {
    totalUprc: Number,
    tran: Object,
  },
  methods: {
    setCard() {
      if (this.tran.HEADER.TOT_SALES_AMT >= 50000) {
        this.$emit('setInstalment');
      } else {
        this.$emit('setCard');
      }
    },
    async cancelPayment() {
      if (!this.cancelYn) {
        this.cancelYn = true;
        this.$store.dispatch('startIdle');
        this.$emit('closeCard');
      }
    },
    paymentEnd() {
      let tranObj = {
        tranNo: this.tran.tranNo,
        orderNo: this.tran.orderNo,
        payType: 'CARD',
        totalUprc: this.totalUprc,
      };
      this.$emit('setPayComplete', tranObj);
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  components: {

  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style scoped></style>
